import React from "react";
import { PRINCIPIOS, RETRO } from "@/content/site";
import { PQ } from "@/content/pesquisa";
import { Container, Eyebrow, Reveal } from "@/components/site/ui";

const PerguntaCentral = () => (
    <section data-testid="home-pergunta" data-section-id="pergunta" className="relative bg-[#F2EFE5] text-[#0E2018] py-28 md:py-40 overflow-hidden">
        <div aria-hidden="true" className="absolute inset-0 paper-grain" />
        <Container className="relative">
            <Reveal>
                <Eyebrow light>{RETRO.eyebrow}</Eyebrow>
                <p data-testid="pergunta-central" className="font-serif font-light text-[24px] sm:text-[30px] lg:text-[38px] leading-[1.32] tracking-[-0.01em] max-w-5xl text-balance">
                    {PQ.investigacao.ampla}
                </p>
                <p className="mt-4 font-sans text-[10px] uppercase tracking-[0.26em] text-[#6b6a52]">{PQ.investigacao.amplaLabel}</p>
                <p data-testid="principio-lentes" className="mt-12 font-serif italic font-light text-[19px] md:text-[23px] leading-[1.5] border-l-2 border-[#C7A659] pl-6 max-w-3xl">
                    {PRINCIPIOS.lentes}
                </p>
                <p data-testid="frase-realidade" className="mt-6 pl-6 font-sans font-light text-[13.5px] tracking-[0.02em] text-[#6b6a52]">
                    {PRINCIPIOS.realidade}
                </p>
            </Reveal>
        </Container>
    </section>
);

export default PerguntaCentral;
